import React, { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';
import Collapse from 'react-bootstrap/Collapse';
import { getWindowWidth } from '../../scripts/helpers';
import IconsHolder from '../icons-holder/IconsHolder';
interface ICollapseContext {
  id: string;
  toggled: boolean;
  setToggled: (item: boolean) => void;
}

const CollapseContext = createContext<ICollapseContext>({
  toggled: false,
  id: '',
  setToggled: () => {},
});

interface Props {
  [key: string]: any;
  className: string;
  children?: ReactNode;
  Button: any;
  Body: any;
}
function useCollapseContext() {
  var context = useContext(CollapseContext);

  if (!context) {
    throw new Error(
      'Child components of Collapse cannot be rendered outside the Collapse component!',
    );
  }
  return context;
}

export const CardsExpendableSteps: React.FC<{
  children: ReactNode | ReactNode[];
  id: string;
  className?: string;
  defaultToggle?: boolean;
}> = ({ children, id, className, defaultToggle }) => {
  var [toggled, setToggled] = useState(defaultToggle || false);
  return (
    <CollapseContext.Provider value={{ id, toggled, setToggled }}>
      <div className={`expanded-card ${className || ''}`}>
        <div className="py-2 py-lg-0 h-100 d-flex flex-column">
          <div
            className={`${
              toggled ? 'expanded' : ''
            } px-3 px-lg-0 h-100 d-flex flex-column flex-wrap`}>
            {children}
          </div>
        </div>
      </div>
    </CollapseContext.Provider>
  );
};
export const CardsExpendableStepsHeading: React.FC<{
  children: ReactNode | ReactNode[];
  className?: string;
  [key: string]: any;
  step?: string;
}> = ({ className, children, step, ...restProps }) => {
  const useCurrentWidth = () => {
    // timeoutId for debounce mechanism
    let timeoutId: any = null;
    const resizeListener = () => {
      // prevent execution of previous setTimeout
      clearTimeout(timeoutId);
      // change width from the state object after 200 milliseconds
      timeoutId = setTimeout(() => setWidth(getWindowWidth()), 200);
    };
    if (typeof window !== 'undefined') {
      // set resize listener
      window.addEventListener('resize', resizeListener);
      // clean up function
      return () => {
        // remove resize listener
        window.removeEventListener('resize', resizeListener);
      };
    }
  };
  var { id, toggled, setToggled } = useCollapseContext();
  const [width, setWidth] = useState(getWindowWidth());

  useCurrentWidth();

  return (
    <h3 className="h5 mb-0 w-100">
      <button
        {...restProps}
        disabled={width > 991}
        className={`${toggled ? '' : 'collapsed'} ${
          className || ''
        } reset-btn expanded-button text-secondary`}
        onClick={(e) => {
          if (restProps.onClick) {
            restProps.onClick(e);
          }
          setToggled(!toggled);
        }}
        aria-controls={id}
        aria-expanded={toggled}>
        {step && (
          <IconsHolder
            className="me-3 me-lg-0 mb-lg-3"
            step={step}
            variant="secondary"
          />
        )}
        <span className="d-lg-block w-lg-100">{children}</span>
      </button>
    </h3>
  );
};

export const CardsExpendableStepsBody: React.FC<{
  children: ReactNode | ReactNode[];
  className?: string;
}> = ({ className, children }) => {
  var { id, toggled } = useCollapseContext();

  return (
    <Collapse
      in={toggled}
      className="flex-fill">
      <div id={id}>
        <div className={`${className || ''} pb-4 pb-lg-0 d-flex flex-wrap h-100 expandable-body`}>
          {children}
        </div>
      </div>
    </Collapse>
  );
};
